import RCPOHeader from './Header'
import { Footer as GassanFooter, Header as GassanHeader } from '@components/Page'
import React, { FC } from 'react'
import RCPOFooter from './Footer'

type RCPOPageProps = {
  children: React.ReactNode
}

export const RCPOPage: FC<RCPOPageProps> = ({ children }) => {
  return (
    <>
      <GassanHeader initialVariant="absolute" />
      <div className="mx-auto w-full max-w-[109rem]">
        <RCPOHeader />
        {children}
        <RCPOFooter />
      </div>
      <GassanFooter />
    </>
  )
}
